<script lang="ts">
  import type { Snippet } from "svelte";

  let {
    icon = "○",
    title,
    hint,
    children,
  }: {
    icon?: string;
    title: string;
    hint?: string;
    children?: Snippet;
  } = $props();
</script>

<div class="text-center px-5 py-11 text-muted">
  <div class="text-2xl leading-none mb-3 text-border-strong" aria-hidden="true">{icon}</div>
  <p class="m-0 text-md font-semibold text-ink">{title}</p>
  {#if hint}<p class="mt-1.5 mb-0 text-sm">{hint}</p>{/if}
  {#if children}<div class="mt-4 flex justify-center">{@render children()}</div>{/if}
</div>
